import { message } from 'antd'
import { useContext, useEffect, useRef } from 'react'
import { AuthContext } from '../../store/auth'
import { getUserCookie } from '../../utils/helperFunctions/cookieToken'

const INACTIVITY_EVENTS = [
  'load',
  'mousemove',
  'mousedown',
  'click',
  'scroll',
  'keydown',
]

const AppLogout = ({ children }) => {
  const { logout, userId } = useContext(AuthContext)
  const timerRef = useRef(null)

  // Adds window listeners that reset a timer to logout the user after 30
  // Minutes of inactivity. Scoped to `userId` (not a mount-once effect) so a
  // logout/login cycle always tears down and recreates this cleanly — a
  // timer left running from a prior session must never fire logout() into a
  // newly-started one.
  useEffect(() => {
    if (!userId) return undefined

    const timeOfUserInactivity = 30 * 60 * 1000

    const resetTimer = () => {
      if (timerRef.current) clearTimeout(timerRef.current)
    }

    const handleActivity = () => {
      resetTimer()
      if (!getUserCookie()) return
      timerRef.current = setTimeout(() => {
        message.loading({
          content: `Signing you out...`,
          duration: 5,
          onClose: logout,
        })
      }, timeOfUserInactivity)
    }

    // Start the countdown immediately so a session with zero activity still
    // times out after 30 minutes, instead of waiting for a first event.
    handleActivity()

    INACTIVITY_EVENTS.forEach((item) => {
      window.addEventListener(item, handleActivity)
    })

    return () => {
      resetTimer()
      INACTIVITY_EVENTS.forEach((item) => {
        window.removeEventListener(item, handleActivity)
      })
    }
  }, [userId, logout])

  return children
}

export default AppLogout
